interface Props {
  resMsg: string;
}
const Badge = ({ resMsg }: Props) => {
  const error = resMsg.split(':');
  let data: any[] = [];
  if (error[error.length - 1].includes(',')) {
    const dataSet = error.pop();
    data = dataSet !== undefined ? dataSet.split(',') : [];
  }

  return (
    <div className="mt-3">
      {error.map((d, idx) => (
        <p
          className={`mb-0 text-dark ${data.length ? '' : 'text-center'}`}
          key={d.toString()}
        >
          {error[idx]}
          {data.length >= 1 ? ':' : ''}
        </p>
      ))}
      {data.map((d, idx) => (
        <span
          className="badge bg-white text-primary m-1 border"
          key={d.toString()}
        >
          {data[idx]}
        </span>
      ))}
    </div>
  );
};

export default Badge;